import React from 'react'
import { withRouter } from 'react-router-dom'
import SubLink from 'containers/SubLink'
import clsx from 'clsx'
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core'
import urlConstructor from 'utils/urlConstructor'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import useTeamFeature from 'hooks/useTeamFeature'
import PropTypes from 'prop-types'
import { List } from './styledComponents'
import menu from './constants/menu'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
  },
  MuiListItemIcon: {
    '& .MuiSvgIcon-root': {
      width: 16,
      height: 16,
    },
  },
  MuiListItemText: {
    marginBottom: 6,
    '& .MuiTypography-root': {
      fontSize: 10,
    },
  },
  teaserOverlay: {
    width: 40,
    textAlign: 'center',
    color: theme.palette.background.paper,
    borderRadius: 15,
    fontSize: 12,
    background: `linear-gradient(120deg,${theme.palette.primary.main} 45%, ${theme.palette.background.paper} 100%)`,
  },
}))

const Sidebar = ({
  match: {
    params: { teamUuid, seasonId },
  },
  location: { pathname },

  onClose,
}) => {
  const classes = useStyles()
  const mainPagePathname = urlConstructor(teamUuid, seasonId)

  return (
    <>
      {menu.map(
        ({ to, title, icon, featureKey, isFullPath, rootPath, target, id }) => {
          /**
           * Determines if the menu item should be displayed based on feature flags.
           *
           * - If `featureKey` is provided, `useTeamFeature(featureKey)` is called to check feature availability.
           * - If `featureKey` is **not** provided, it falls back to `{ enabled: true, tease: false }`, ensuring:
           *   - The item **is always visible** (`enabled: true`).
           *   - No teaser behavior applies (`tease: false`).
           */
          const { enabled, tease } = featureKey
            ? useTeamFeature(featureKey)
            : { enabled: true, tease: false }

          // If featureKey exists and is disabled (with no tease mode), hide the menu item.
          if (featureKey && !enabled && !tease) return null

          return (
            <List component="nav" className={classes.root} id={id} key={to}>
              <ListItem
                to={to}
                button
                component={SubLink}
                onClick={onClose}
                isFullPath={isFullPath}
                target={target}
                isActive={!rootPath && pathname === mainPagePathname}
                className={
                  (!rootPath && pathname === mainPagePathname) ||
                  (rootPath && pathname.includes(mainPagePathname + rootPath))
                    ? 'selected'
                    : ''
                }
              >
                <ListItemIcon
                  className={clsx({ [classes.MuiListItemIcon]: tease })}
                >
                  {icon}
                </ListItemIcon>
                <ListItemText
                  primary={title}
                  className={clsx({ [classes.MuiListItemText]: tease })}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                />
                {tease && <div className={classes.teaserOverlay}>Pro</div>}
              </ListItem>
            </List>
          )
        }
      )}
    </>
  )
}

Sidebar.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default compose(
  withLocalize,
  connect(({ team }) => ({
    team,
  })),
  withRouter
)(Sidebar)
